module.exports = "\n#plusButton {\n  position: fixed;\n  right: 1rem;\n  bottom: 1rem;\n}\n\n.no-margin{\n  margin:  0 !important;\n}\n\n.modal-content h4{\n  text-transform: uppercase;\n}\n\n.alert-danger{\n  color: #f21a1a;\n}\n\n#modalAddFriend h4{\n  font-weight: bold;\n  padding: 0 .75rem;\n  /* border-bottom: 1px solid gray; */\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/addFriend/addFriend.component.css
// module id = ./src/app/components/addFriend/addFriend.component.css
// module chunks = main